import * as React from 'react';
import '@/components/MultiSkuModalGolden/Components/Remark/index.css';
import { withTranslation } from '@sailor/i18n-mach-pro';

interface IProps {
  defaultRemark?: string;
  scrollToEdit: VoidFunction;
  scrollToSubmit: VoidFunction;
}

interface IState {
  remarkLength: number;
}

const Toast = Mach.requireModule('Toast');
class Remark extends React.Component<any, IState> {
  input!: any;
  remarkMaxLength = 70;

  constructor(props: IProps) {
    super(props);
    this.state = {
      remarkLength: this.props.defaultRemark?.length || 0,
    };
    if (this.props.defaultRemark?.length > 0) {
      setTimeout(() => {
        if (this.input) {
          this.input.setValue(this.props.defaultRemark);
        }
      }, 200);
    }
  }

  inputBlur = () => {
    if (this.input) {
      this.input.blur?.();
    }
  }

  inputText = () => {
    if (this.input) {
      return this.input.value();
    } else {
      return this.props.defaultRemark || '';
    }
  }

  render() {
    const { t } = this.props;
    const inputTitle = t('cartlayer_remark_1');
    const inputSubTitle = t('cartlayer_remark_2');
    // ❗️❗️❗️placeholder的文案不可轻易变更，超过一行iOS上显示会有问题❗️❗️❗️
    // ❗️❗️❗️iOS的textarea组件中的placeholder换行所需的高度比输入文案所需的高度要高❗️❗️❗️
    // ❗️❗️❗️这部分由于UI原因不能增高了，所以要求PM最好保证placeholder的文案再一行内写下❗️❗️❗️
    const defaultText = t('cartlayer_remark_3');
    return (
      <view className="detail-content-input">
        <text className="input-title" content={inputTitle} />
        <text className="input-sub-title" content={inputSubTitle} />
        {/* 抢焦点的黑魔法，专门用于适配某些自动获取焦点的安卓手机 */}
        {Mach.env.isAndroid && <input style={{ width: 0, height: 0, backgroundColor: '#FFCCDD' }} />}
        <view className="input-container">
          <view className="input">
            <textarea
              ref={(ref) => {
                this.input = ref;
              }}
              // defaultValue={defaultRemark}
              confirmType="done"
              placeholderColor="#808080"
              cursorColor="#222426"
              className="dialog-input"
              placeholder={defaultText}
              maxLength={this.remarkMaxLength}
              disabled={false}
              onFocus={this.props.scrollToEdit}
              onBlur={this.props.scrollToSubmit}
              onKeyboardHeightChanged={() => {}}
              onChange={() => {
                if (this.input) {
                  const remarkLength = this.input.value()?.length || 0;
                  if (remarkLength <= this.remarkMaxLength) {
                    this.setState({
                      remarkLength,
                    });
                  }
                }
              }}
            />
          </view>
          <view className="remark-length-container">
            <text style={{ color: '#808080' }} content={`${this.state.remarkLength}/${this.remarkMaxLength}`} />
          </view>
        </view>
      </view>
    );
  }
}

export default withTranslation('', {
  withRef: true,
})(Remark);
